<template>
  <div>
    <data-table :service="service"
                service-method="getCreditLogs"
                :service-path="servicePath"
                :go-to-details-on-row-click="false"
                :clickable="false"
                :entity="entity"
                :filters="filters"
                :columns="columns"
                ref="table">
      <template slot="updated_at" slot-scope="{row}">
        {{$formatDate(row.updated_at, FRIENDLY_DATETIME_FORMAT)}}
      </template>
      <template slot="amount" slot-scope="{row}">
        {{row.amount}}
      </template>
      <template slot="client" slot-scope="{row}">
        <router-link v-if="row.client" @click.native.stop="" :to="`/contacts/clients/${row.client ? row.client.uuid : $t('generic.na')}`">
          {{row.client ? row.client.name : $t('generic.na')}}
        </router-link>
        <span v-else>{{row.client ? row.client.name : $t('generic.na')}}</span>
      </template>
      <template slot="order" slot-scope="{row}">
        <router-link @click.native.stop="" :to="`/ecommerce/orders/${row.order.uuid}`">
          {{row.order ? row.order.name : $t('generic.na')}}
        </router-link>
      </template>

    </data-table>
  </div>
</template>
<script>
  import CreditService from 'src/services/CreditService'
  import entities from 'src/config/entities'
  import { FRIENDLY_DATETIME_FORMAT } from 'src/config/dateUtils'

  export default {
    name: 'credit-logs',
    data () {
      return {
        service: CreditService,
        entity: entities.CREDIT,
        FRIENDLY_DATETIME_FORMAT,
      }
    },
    computed: {
      columns () {
        return [
          {
            prop: 'updated_at',
            label: this.$t('credit.list.labels.date'),
            minWidth: '150px',
            sortable: true,
          },
          {
            prop: 'amount',
            label: this.$t('credit.list.labels.amount'),
            minWidth: '150px',
            sortable: true,
          },
          {
            prop: 'client',
            label: this.$t('credit.list.labels.client'),
            minWidth: '150px',
          },
          {
            prop: 'order',
            label: this.$t('credit.list.labels.order'),
            minWidth: '150px',
          }
        ]
      },
      servicePath () {
        return `/transactions`
      },
      filters () {
        return [
          {
            key: 'with',
            value: 'client,order'
          },
          {
            key: 'sort',
            value: '+updated_at'
          }
        ]
      }
    }
  }
</script>
<style>
</style>
